import { apolloClient } from '@/plugins/apollo';
import {
  CreateDataExtractionReport,
  SubmitDataExtractionReport,
} from '@/graphql';
import { DataExtractionReport } from '@/models';
import { ReportState } from '@/enums';
import { appendToListSubQueryCache } from '@/modules/cacheHelpers';

const reportsBeingCreated = {};

const actions = {
  async createForReference(context, { referenceId, reviewerId }) {
    // If we're already creating the report, reuse the same promise instead of having the second one fail
    let promisesForReference = reportsBeingCreated.referenceId;
    if (!promisesForReference) {
      reportsBeingCreated.referenceId = promisesForReference = {};
    }
    if (promisesForReference.reviewerId) {
      return promisesForReference.reviewerId;
    }

    const report = new DataExtractionReport({
      state: ReportState.PENDING,
      reference: { id: referenceId },
      reviewer: { id: reviewerId },
    });
    promisesForReference.reviewerId = context.dispatch(
      'create',
      report
    );
    try {
      return await promisesForReference.reviewerId;
    } finally {
      promisesForReference.reviewerId = null;
    }
  },
  async create(context, report) {
    const response = await apolloClient.mutate({
      mutation: CreateDataExtractionReport,
      variables: {
        dataExtractionReport: report.creationData(),
      },
      refetchQueries: [
        'GetDataExtractionPage',
        'GetConsensusReviewPage',
      ],
      awaitRefetchQueries: true,
      update: (cache, { data: { createDataExtractionReport } }) => {
        // Append the new report to the cache of Reference.dataExtractionReports
        appendToListSubQueryCache(
          cache,
          report.reference.id,
          'Reference',
          'dataExtractionReports',
          createDataExtractionReport
        );
      },
    });
    return new DataExtractionReport(
      response.data.createDataExtractionReport
    );
  },
  async submit(context, { report, resolveConflicts = false }) {
    const response = await apolloClient.mutate({
      mutation: SubmitDataExtractionReport,
      variables: {
        id: report.id,
        resolveConflicts,
      },
      refetchQueries: [
        'GetReviewForDataExtractionPage',
        'GetReviewForConsensusPage',
        'GetDataExtractionPage',
        'GetConsensusReviewPage',
      ],
      awaitRefetchQueries: true,
    });
    return new DataExtractionReport(
      response.data.submitDataExtractionReport
    );
  },
};

export default {
  namespaced: true,
  actions,
};
